import moment from 'moment';


function formatDate(date) {
  return moment(date).utc().format('ll');
}

function formatDateTime(date) {
  return moment(date).utc().format('lll');
}

function monthOfDate(date) {
  return moment(date).utc().format('MMM');
}

function monthNumberOfDate(date) {
  return moment(date).utc().format('l');
}

function dayOfDate(date) {
  return moment(date).utc().format('DD');
}

function timeOfDate(date) {
  return moment(date).utc().format('hh:mm');
}

function differenceTime(from, to) {
  return moment.utc(moment(to, "DD/MM/YYYY HH:mm:ss").diff(moment(from, "DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss");
}

function formatDateByDay(date) {
  return moment(date).utc().format('YYYY-MM-DD');
}
function formatDateByMonth(date) {
  return moment(date).utc().format('YYYY-MM');
}

export {
  formatDate as default,
  formatDateTime,
  dayOfDate,
  monthOfDate,
  timeOfDate,
  differenceTime,
  monthNumberOfDate,
  formatDateByDay,
  formatDateByMonth,
}